import React, { Component } from 'react';
import R from 'ramda';
import _ from 'lodash';
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import actions from '../../redux/actions';
import { getUserNameByInviteId } from '../../utils';
// import PhotoContainer from '../PhotoContainer';
import checkSentenceAccepted from '../Deals/DealEditPages/helpers/checkSentenceAccepted';

class AgreementSentence extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      editRedline: false,
      sentenceChange: null,
      redlineIndex: -1,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.refs.changeContent) {
      const { acceptedContent } = this.getSentenceChanges();
      let value = acceptedContent ? acceptedContent : this.props.children;
      value = this.state.sentenceChange
        ? this.state.sentenceChange.changes.content
        : value;

      if (value.includes('<h5>')) {
        findDOMNode(this.refs.changeContent).setAttribute('type', 'title');
        value = value.replace('<h5>', '');
        value = value.replace('</h5>', '');
      } else {
        findDOMNode(this.refs.changeContent).setAttribute('type', 'content');
      }

      findDOMNode(this.refs.changeContent).value = value;
    }
  }

  saveContent() {
    const { profile, deal, section, index, isCurrentVersion } = this.props;
    const { sentenceChange } = this.state;
    let content = findDOMNode(this.refs.changeContent).value;
    if (findDOMNode(this.refs.changeContent).getAttribute('type') === 'title') {
      content =
        content.split('\n').length > 1 ? content : `<h5>${content}</h5>`;
    }

    if (sentenceChange) {
      let changes = sentenceChange.changes;
      if (changes.content !== content) {
        changes.content = content;

        this.props.createDealChange({
          deal: deal.id,
          user: profile.id,
          type: 'agreement-text-sentence',
          changes: JSON.stringify({
            sentence: changes,
            isCurrentVersion: isCurrentVersion,
          }),
        });
      }
    } else {
      const changes = {
        content,
        section,
        index,
      };
      this.props.createDealChange({
        deal: deal.id,
        user: profile.id,
        type: 'agreement-text-sentence',
        changes: JSON.stringify({
          sentence: changes,
          isCurrentVersion: isCurrentVersion,
        }),
      });
    }

    this.setState({
      edit: false,
      editRedline: false,
      sentenceChange: null,
      redlineIndex: -1,
    });

    return false;
  }

  handleDelete(sentenceChange) {
    if (sentenceChange) {
      this.props.deleteDealChange({
        id: sentenceChange.id,
        deal: this.props.deal.id,
      });
      if (
        this.state.sentenceChange &&
        this.state.sentenceChange.id === sentenceChange.id
      ) {
        this.setState({ sentenceChange: null });
      }
    }

    return false;
  }

  handleAccept(sentenceChange) {
    const { profile, deal, agreement, invites, dealUsers, section } =
      this.props;

    if (sentenceChange) {
      let changes = sentenceChange.changes;
      changes.accepts = changes.accepts || [];
      changes.rejects = changes.rejects || [];

      let accepts = [...changes.accepts];
      let rejects = [...changes.rejects];

      if (accepts.indexOf(profile.id) === -1) {
        accepts.push(profile.id);

        const index = rejects.indexOf(profile.id);
        if (index !== -1) {
          rejects.splice(index, 1);
        }

        if (
          accepts.length !== changes.accepts.length ||
          rejects.length !== changes.rejects.length
        ) {
          changes.accepts = accepts;
          changes.rejects = rejects;

          const acceptedChange = checkSentenceAccepted(
            changes,
            sentenceChange.user,
            invites,
            dealUsers
          );
          if (acceptedChange) {
            const agreementSentence = this.getAgreementSentence();
            if (agreementSentence) {
              this.props.updateAgreementSentence(agreementSentence.id, {
                agreement: agreement.id,
                content: changes.content,
              });
            } else {
              this.props.createAgreementSentence({
                agreement: agreement.id,
                section: section,
                sentence: index,
                content: changes.content,
              });
            }

            this.props.updateDealChange({
              id: sentenceChange.id,
              deal: deal.id,
              type: 'agreement-text-sentence-log',
              changes: JSON.stringify({
                sentence: changes,
                isCurrentVersion: sentenceChange.isCurrentVersion,
              }),
            });
          } else {
            this.props.updateDealChange({
              id: sentenceChange.id,
              deal: deal.id,
              changes: JSON.stringify({
                sentence: changes,
                isCurrentVersion: sentenceChange.isCurrentVersion,
              }),
            });
            this.props.alert('success', 'You have accepted this redline.');
          }
        }
      }
    }

    return false;
  }

  handleReject(sentenceChange) {
    const { profile, deal } = this.props;

    if (sentenceChange) {
      let changes = sentenceChange.changes;
      changes.accepts = changes.accepts || [];
      changes.rejects = changes.rejects || [];

      let accepts = [...changes.accepts];
      let rejects = [...changes.rejects];

      if (rejects.indexOf(profile.id) === -1) {
        rejects.push(profile.id);

        const index = accepts.indexOf(profile.id);
        if (index !== -1) {
          accepts.splice(index, 1);
        }

        if (
          accepts.length !== changes.accepts.length ||
          rejects.length !== changes.rejects.length
        ) {
          changes.accepts = accepts;
          changes.rejects = rejects;
          this.props.updateDealChange({
            id: sentenceChange.id,
            deal: deal.id,
            isCurrentVersion: sentenceChange.isCurrentVersion,
            changes: JSON.stringify({
              sentence: changes,
              isCurrentVersion: sentenceChange.isCurrentVersion,
            }),
          });
          this.props.alert('success', 'You have rejected this redline.');
        }
      }
    }

    return false;
  }

  showEditBox() {
    return (
      <div className="edit-box">
        <textarea ref="changeContent"></textarea>
        <div>
          <a onClick={(e) => this.saveContent()}>Submit</a>
          <a
            onClick={(e) =>
              this.setState({
                edit: false,
                editRedline: false,
                sentenceChange: null,
                redlineIndex: -1,
              })
            }
          >
            Cancel
          </a>
        </div>
      </div>
    );
  }

  getAgreementSentence() {
    const { section, agreement } = this.props;

    if (agreement) {
      const sentences = agreement.sentences || [];
      const sentence = R.find(
        R.whereEq({
          section: section,
          // sentence: index
        })
      )(sentences);

      return sentence;
    }

    return null;
  }

  getSentenceChanges() {
    const sentenceChanges = [];
    let acceptedContent = null;

    const agreementSentence = this.getAgreementSentence();
    if (agreementSentence) {
      acceptedContent = agreementSentence.content;
    }

    this.props.dealChanges.forEach((dealChange) => {
      if (
        dealChange.type === 'agreement-text-sentence' ||
        dealChange.type === 'agreement-text-sentence-log'
      ) {
        const changes = JSON.parse(dealChange.changes);
        if (
          changes &&
          changes.sentence &&
          changes.sentence.section === this.props.section &&
          changes.sentence.index === this.props.index
        ) {
          const acceptedChange = checkSentenceAccepted(
            changes.sentence,
            dealChange.user,
            this.props.invites,
            this.props.dealUsers
          );

          if (acceptedChange) {
            acceptedContent = changes.sentence.content;
          } else {
            sentenceChanges.push({
              id: dealChange.id,
              changes: changes.sentence,
              user: dealChange.user,
              isCurrentVersion: changes.isCurrentVersion || false,
            });
          }
        }
      }
    });

    return { sentenceChanges, acceptedContent };
  }

  // renderUserAvatars(userIds) {
  //   const { members } = this.props;

  //   if (userIds && userIds.length) {
  //     const user = getMemberByUserId(userIds[0], members);
  //     return (
  //       <div className="user-avatars">
  //         <div className="user-photo">
  //           <PhotoContainer className="photo-container" image={user ? user.avatar : ''} defaultImg="user" />
  //         </div>
  //         {userIds.length > 1 ?
  //           <span>+{userIds.length - 1}</span>
  //           : null
  //         }
  //       </div>
  //     );
  //   }
  // }

  renderSentenceChange(sentenceChange, i) {
    const { isCurrentVersion, invites, profile } = this.props;

    if (isCurrentVersion) {
      if (!sentenceChange.isCurrentVersion) {
        return;
      }
    } else {
      if (
        sentenceChange.isCurrentVersion ||
        profile.id !== sentenceChange.user
      ) {
        return;
      }
    }

    const redlineCreatorName = getUserNameByInviteId(
      sentenceChange.user,
      invites
    );
    const sentenceArray = _.isArray(sentenceChange.changes.content)
      ? sentenceChange.changes.content
      : sentenceChange.changes.content.split('\n');

    if (this.state.editRedline && i === this.state.redlineIndex) {
      return <div key={i}>{this.showEditBox()}</div>;
    }

    let acceptUserList = [];
    if (sentenceChange.changes.accepts) {
      acceptUserList = sentenceChange.changes.accepts.map((id) => {
        const userName = getUserNameByInviteId(id, invites);
        if (userName !== '') {
          return [...acceptUserList, userName];
        } else {
          return [...acceptUserList];
        }
      });
    }

    let rejectUserList = [];
    if (sentenceChange.changes.accepts) {
      rejectUserList = sentenceChange.changes.rejects.map((id) => {
        const userName = getUserNameByInviteId(id, invites);
        if (userName !== '') {
          return [...rejectUserList, userName];
        } else {
          return [...rejectUserList];
        }
      });
    }

    return (
      <div className="redline" key={i}>
        <OverlayTrigger
          overlay={<Tooltip id="tooltip-split">{redlineCreatorName}</Tooltip>}
          placement="top"
        >
          <div>
            {sentenceArray.map((item, index) => (
              <p
                key={index}
                style={{ margin: 0 }}
                dangerouslySetInnerHTML={{
                  __html: item === '' ? '<br />' : item,
                }}
              />
            ))}
          </div>
        </OverlayTrigger>

        {sentenceChange.user === profile.id ? (
          <div className="hover-box">
            <a
              onClick={(e) =>
                this.setState({
                  editRedline: true,
                  sentenceChange,
                  redlineIndex: i,
                })
              }
            >
              Edit
            </a>
            <a onClick={(e) => this.handleDelete(sentenceChange)}>Delete</a>
          </div>
        ) : (
          <div className="hover-box">
            {acceptUserList.length === 0 ? (
              <div>
                <a onClick={(e) => this.handleAccept(sentenceChange)}>Accept</a>
                {/* {sentenceChange.changes.accepts && this.renderUserAvatars(sentenceChange.changes.accepts)} */}
              </div>
            ) : (
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-split">
                    {acceptUserList.map((item, index) => (
                      <div key={index}>{item}</div>
                    ))}
                  </Tooltip>
                }
                placement="top"
              >
                <div>
                  <a onClick={(e) => this.handleAccept(sentenceChange)}>
                    Accept
                  </a>
                </div>
              </OverlayTrigger>
            )}

            {rejectUserList.length === 0 ? (
              <div>
                <a onClick={(e) => this.handleReject(sentenceChange)}>Reject</a>
                {/* {sentenceChange.changes.accepts && this.renderUserAvatars(sentenceChange.changes.accepts)} */}
              </div>
            ) : (
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-split">
                    {rejectUserList.map((item, index) => (
                      <div key={index}>{item}</div>
                    ))}
                  </Tooltip>
                }
                placement="top"
              >
                <div>
                  <a onClick={(e) => this.handleReject(sentenceChange)}>
                    Reject
                  </a>
                </div>
              </OverlayTrigger>
            )}
          </div>
        )}
      </div>
    );
  }

  render() {
    const { children, profile, type, editable, isCurrentVersion } = this.props;

    const { sentenceChanges, acceptedContent } = this.getSentenceChanges();
    const isAttorney = profile.attorney;

    // get accepted sentences
    const content = acceptedContent ? acceptedContent : children;

    return type === 'deal-edit' && editable ? (
      <div className="agreement-sentence">
        <div className={`sentence ${isAttorney && 'is-attorney'}`}>
          {content.split('\n').map((item, index) => (
            <p
              key={index}
              className="agreement-sentence"
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
          {isAttorney ? (
            <span className="hover-box">
              <a
                onClick={(e) =>
                  this.setState({ edit: true, sentenceChange: null })
                }
              >
                Edit
              </a>
            </span>
          ) : (
            !isAttorney &&
            !isCurrentVersion && (
              <span className="hover-box">
                <a
                  onClick={(e) =>
                    this.setState({ edit: true, sentenceChange: null })
                  }
                >
                  Edit
                </a>
              </span>
            )
          )}
        </div>

        {sentenceChanges &&
          sentenceChanges.map((change, i) =>
            this.renderSentenceChange(change, i)
          )}

        {this.state.edit && this.showEditBox()}
      </div>
    ) : (
      <p
        className="agreement-sentence"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  deal: state.deals.selectedDeal,
  dealChanges: state.deals.dealChanges,
  dealUsers: state.dealUsers.dealUsers,
  invites: state.invites.invites,
  agreement: state.agreements.selectedAgreement,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  createDealChange: (dealChange) => {
    dispatch(actions.createDealChange(dealChange));
  },
  deleteDealChange: (dealChange) => {
    dispatch(actions.deleteDealChange(dealChange));
  },
  updateDealChange: (dealChange) => {
    dispatch(actions.updateDealChange(dealChange));
  },
  createAgreementSentence: (data) => {
    dispatch(actions.createAgreementSentence(data));
  },
  updateAgreementSentence: (id, data) => {
    dispatch(actions.updateAgreementSentence(id, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AgreementSentence);



// WEBPACK FOOTER //
// src/components/Agreements/AgreementSentence.jsx